import {
    Box,
    Typography,
    Button,
} from '@mui/material';

import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BasePageLayout from '../layout/BasePageLayout';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <BasePageLayout title={<Trans i18nKey={'entschuldigung'} ns='notFoundPage'>Entschuldigung,</Trans>}>
                    <Box sx={{ width: 'fit-content', height: '600px' }}>
                    <Typography variant='h6'>
                            <Trans i18nKey={'notFound'} ns='notFoundPage'>wir haben keine Seite zu dieser Webadresse gefunden.</Trans>
                        </Typography>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Button variant='contained' onClick={() => navigate('/')}>
                                <Trans i18nKey={'zurückZumStart'} ns='unauthorizedPage'>Zurück zur Startseite</Trans>
                            </Button>
                        </Box>
                    </Box>
                </BasePageLayout>
            </Box>

        </>
    );
};

export default NotFoundPage
